import { useQuery } from "react-query";

import { useLicenses } from "~/entity/Licenses/hooks/useLicenses";
import {
  ILicensePositionGroupRowApi,
  ILicensesOverviewParams,
} from "~/entity/Licenses/model/schema";
import { getAvailabilityColor } from "~/shared/lib/licenseAvailability";

import { ILicenseOrganizationRow } from "./types";

const mapPositionGroupRow = (
  row: ILicensePositionGroupRowApi,
  index: number,
): ILicenseOrganizationRow => {
  const codes = row.positions.map((position) => position.code).filter(Boolean);
  const names = row.positions.map((position) => position.name).filter(Boolean);
  const method = (row.method ?? "").trim();

  return {
    id:
      row.instanceId != null ? `instance-${row.instanceId}` : `index-${index}`,
    instanceId: row.instanceId,
    positionCode: codes.join(", "),
    positionName: names.join(", ") || method || "-",
    availabilityColor: getAvailabilityColor(row.available, row.total),
    totalQuantity: row.total,
    assignedQuantity: row.assigned,
    usedQuantity: row.used,
    frozenQuantity: row.frozen,
    freeQuantity: row.available,
    expiredQuantity: row.expired,
  };
};

export const useOrganizationLicenses = (params?: ILicensesOverviewParams) => {
  const { queryKeys, getLicensesPositionGroups } = useLicenses();

  const query = useQuery({
    queryKey: queryKeys.positionGroups(params),
    queryFn: () => getLicensesPositionGroups(params),
    enabled: Boolean(params?.dealerId) || Boolean(params?.organizationId),
  });

  const data = query.data?.data;
  const rows =
    data?.level === "positions" ? data.rows.map(mapPositionGroupRow) : [];

  return {
    ...query,
    rows,
    total: data?.level === "positions" ? data.total : 0,
    statusTotals: data?.level === "positions" ? data.statusTotals : undefined,
  };
};
